export default "__VITE_ASSET__DIdW98nD__"